export default class Instagram {
  constructor() {
    const isInstagramReferral = this.getQuerySearch();

    if (! isInstagramReferral) return;

    if (this.referralCookieExists()) return;

    document.documentElement.style.overflow = 'hidden';

    this.setupButtonsClick();
  }

  getQuerySearch() {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);

    if (urlParams.get('instareferral')) {
      this.popup = 'instareferral';
      return urlParams.get('instareferral');
    }

    if (urlParams.get('ig_biomarkers')) {
      this.popup = 'ig_biomarkers';
      return urlParams.get('ig_biomarkers');
    }

    return false;
  }

  referralCookieExists() {
    const cookies = document.cookie.split(';');

    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i].trim();

      if (cookie.indexOf(this.popup) !== -1) {
        return true;
      }
    }

    return false;
  }

  setupButtonsClick() {
    const confirmBtn = document.querySelector('.confirm');

    confirmBtn.addEventListener('click', () => {
      this.onConfirm();
    });
  }

  onConfirm() {
    const instaRef = document.querySelector('.instaref');

    instaRef.remove();

    const date = new Date();
    date.setTime(date.getTime() + (24 * 60 * 60 * 1000));
    document.cookie = `${this.popup}=1; expires= ${date.toUTCString()}; path=/`;

    document.documentElement.style.overflow = 'auto';

    if (this.popup === 'ig_biomarkers') {
      window.location.href = '/requirements-for-tecelra/?testing=1';
    }
  }
}